import { getMedicineOrderOMSDetailsWithAddress_getMedicineOrderOMSDetailsWithAddress_medicineOrderDetails as OrderDetails } from "graphql/types/getMedicineOrderOMSDetailsWithAddress";
import {
  MedicineCartItem,
  EPrescription,
} from "components/MedicinesCartProvider";
import { getLatestMedicineOrder_getLatestMedicineOrder_medicineOrderDetails as LatestOrderDetailsType } from "graphql/types/getLatestMedicineOrder";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import {
  GetCashbackDetailsOfPlanById,
  GetCashbackDetailsOfPlanByIdVariables,
} from "graphql/types/GetCashbackDetailsOfPlanById";
import { GET_CASHBACK_DETAILS_PLAN_BY_ID } from "graphql/medicines";
import { useApolloClient } from "react-apollo-hooks";
import { format } from "date-fns";

const apiDetails = {
  authToken: process.env.NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN,
  service_url: process.env.NEXT_PUBLIC_PHARMACY_SERVICE_AVAILABILITY,
  cartItemDetails: process.env.NEXT_PUBLIC_PHARMACY_MED_BULK_PRODUCT_INFO_URL,
  medicineDetails: process.env.NEXT_PUBLIC_PHARMACY_MED_PROD_DETAIL_URL,
};

export interface MedicineProduct {
  MaxOrderQty: number;
  url_key: string;
  description: string;
  id: number;
  image: string[] | null;
  is_in_stock: boolean;
  is_prescription_required: "0" | "1"; //1 for required
  name: string;
  price: number;
  special_price: number | string;
  sku: string;
  small_image?: string | null;
  status: number;
  thumbnail: string | null;
  type_id: string;
  mou: string;
  manufacturer: string;
  PharmaOverview: PharmaOverview[];
  category_id: string;
  sell_online: boolean;
  is_express?: string;
  consume_type?: string;
  dose_form_variant?: string;
  vegetarian?: string;
  marketer_name?: string;
  marketer_address?: string;
  is_returnable?: string;
  expiry_date?: string;
  product_information?: string;
  safety_information?: string;
  uses: string;
  size: string;
  key_ingredient: string;
  pack_form?: string;
  pack_size?: string;
  unit_of_measurement?: string | null;
  product_form: string | null;
  dc_availability?: string;
  is_in_contract?: string;
  key_benefits: string | null;
  direction_for_use_dosage: string | null;
}
export interface Brand {
  url_key: string;
  category_id: string;
  image_url: number;
  title: string;
}
export type Doseform = "TABLET" | "INJECTION" | "SYRUP" | "";

export interface PharmaOverview {
  generic: string;
  Doseform: Doseform;
  Unit: string;
  Strength: string;
  SubstituteDrugs: [];
  Overview:
    | {
        Caption: string;
        CaptionDesc: string;
      }[]
    | string;
  NewPharmaOverview?: {
    AboutProduct: string;
    AlcoholContent: string;
    AlcoholTag: string;
    BreastfeedingMothersContent: string;
    BreastfeedingMothersTag: string;
    DrivingContent: string;
    DrivingTag: string;
    KidneyContent: string;
    KidneyTag: string;
    LiverContent: string;
    LiverTag: string;
    Uses: string;
    HowToTake: string;
    SideEffects: string;
    Storage: string;
    StoragePlace: string;
    color: string;
    variant: string;
    flavour_fragrance: string;
    WarningsAndPrecautions: string;
    PregnancyContent: string;
    PregnancyTag: string;
    CompositionContentFAQs?: [
      {
        field_question: string;
        field_answer: string;
      }
    ];
  };
}

export interface MedicineProductDetails extends MedicineProduct {
  similar_products: MedicineProduct[];
  PharmaOverview: PharmaOverview[];
  crosssell_products: MedicineProduct[];
}

export interface MedicineProductDetailsResponse {
  productdp: MedicineProductDetails[];
  message?: string;
}

export interface MedicineProductsResponse {
  product_count: number;
  products: MedicineProduct[];
}

export interface Brand {
  category_id: string;
  image_url: number;
  title: string;
}

export interface BrandsResponse {
  count: number;
  brands: Brand[];
}

export interface Store {
  storeid: string;
  storename: string;
  address: string;
  workinghrs: string;
  phone: string;
  city: string;
  state: string;
  message: string;
}

export interface Clinic {
  CentreType: string;
  CentreCode: string;
  CentreName: string;
  MobileNo: string;
  BusinessZone: string;
  State: string;
  City: string;
  Zone: string;
  Locality: string;
  IsNabl: boolean;
  IsCap: boolean;
}

export interface ClinicDetailsResponse {
  Message: string;
  Status: boolean;
  data: Clinic[];
}

export interface GetDeliveryTimeResponse {
  tat: {
    artCode: string;
    deliverydate: string;
    siteId: string;
  }[];
  errorMSG?: string;
}
interface InventoryCheckApiResponse {
  InvChkResult: {
    Message: string; //"Data Founds" | "Authentication Failure-Invalid Token" | "No Items to Check Inventory"
    Status: boolean;
    item:
      | {
          artCode: string;
          batch: string;
          expDate: string; //'2024-05-30 00:00:00.0'
          mrp: number;
          qoh: number;
        }[]
      | null;
  };
}

export type GooglePlacesType =
  | "route"
  | "sublocality_level_2"
  | "sublocality_level_1"
  | "postal_code"
  | "locality"
  | "administrative_area_level_2"
  | "administrative_area_level_1"
  | "country";

export enum ProductCategory {
  HOT_SELLERS = "1174",
}

export interface PlaceByIdApiResponse {
  result: PlacesApiResponse["results"][0];
}

export interface PlacesApiResponse {
  results: {
    address_components: {
      long_name: string;
      short_name: string;
      types: GooglePlacesType[];
    }[];
    formatted_address: string;
    geometry: {
      location: {
        lat: number;
        lng: number;
      };
      viewport: {
        northeast: {
          lat: number;
          lng: number;
        };
        southwest: {
          lat: number;
          lng: number;
        };
      };
    };
  }[];
}

// MedicineLandingPageAPi
export interface MedicinePageSection {
  url_key: string;
  category_id: string;
  title: string;
  image_url: string;
}
export interface DealsOfTheDaySection {
  url_key: string;
  category_id: string;
  image_url: string;
  position: number;
  products: Array<any>;
}
interface OfferBannerSection {
  category_url_key: string;
  name: string;
  status: "0" | "1";
  image: string; // full url
  sku_url_key: string;
  start_time: string; // '2019-02-10 01:21:00';
  end_time: string;
}

export interface MedicinePageAPiResponse {
  monsoon_essentials: { products: MedicineProduct[] };
  mainbanners: OfferBannerSection[];
  mainbanners_desktop: OfferBannerSection[];
  healthareas: MedicinePageSection[];
  deals_of_the_day: DealsOfTheDaySection[];
  shop_by_category: MedicinePageSection[];
  shop_by_brand: MedicinePageSection[];
  hot_sellers?: { products: MedicineProduct[] };
  categories?: any[];
}

export interface PackageInclusion {
  TestInclusion: string;
  SampleRemarks: string;
  SampleTypeName: string;
  TestParameters: string;
  TestName?: string; // getting TestInclusion value in TestName from API
}

export interface TestPackage {
  ItemID: string;
  ItemCode: string;
  ItemName: string;
  ItemAliasName: string;
  Rate: number;
  LabName: string;
  LabCode: string;
  Panel_ID: number;
  FromAgeInDays: number;
  ToAgeInDays: number;
  Gender: string;
  PackageInClussion: PackageInclusion[];
}

export interface TestsPackageResponse {
  status: boolean;
  message: string;
  data: TestPackage[];
}

export interface GetPackageDataResponse {
  status: boolean;
  message: string;
  data: PackageInclusion[];
}

export interface ServiceAvailabilityResponse {
  axdcCode: string | number;
  city: string;
  serviceable: boolean;
}

export const checkServiceAvailability = (zipCode: string) => {
  return axios
    .get(
      `${process.env.NEXT_PUBLIC_PHARMACY_SERVICEABILITY_API_BASE_URL}/pincode/${zipCode}`,
      {
        headers: {
          Authorization: process.env.NEXT_PUBLIC_PHARMACY_SERVICEABILITY_TOKEN,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      try {
        const {
          axdcCode = "",
          servicable: serviceable = false,
          City: city = "",
        } = res?.data?.response;
        serviceable && sessionStorage.setItem("axdcCode", axdcCode as string);
        sessionStorage.setItem("serviceableCity", city);
        return {
          axdcCode,
          serviceable,
          city,
        };
      } catch (e) {
        return {
          axdcCode: "",
          serviceable: false,
          city: "",
        };
      }
    });
};

export const checkSkuAvailability = (sku: string, pincode: string) => {
  return axios.get(
    `${process.env.NEXT_PUBLIC_INVENTORY_SYNC_URL}/availability?sku=${sku}&pincode=${pincode}`,
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_INVENTORY_SYNC_TOKEN,
        "Content-Type": "application/json",
      },
    }
  );
};

export const checkTatAvailability = (
  items: Items[],
  pincode: string,
  lat: string,
  lng: string
) => {
  return axios.post(
    `${process.env.NEXT_PUBLIC_INVENTORY_SYNC_URL}/v3/tat`,
    {
      items,
      pincode,
      lat,
      lng,
    },
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_INVENTORY_SYNC_TOKEN,
        "Content-Type": "application/json",
      },
    }
  );
};

export const getStoreInventoryApi = (storeid: string, productSku: string) => {
  return axios.post(
    process.env.NEXT_PUBLIC_PHARMACY_GET_STORE_INVENTORY,
    { shopId: storeid, itemdetails: [{ ItemId: productSku }] },
    {
      headers: {
        Authentication:
          process.env.NEXT_PUBLIC_PHARMACY_MED_DELIVERY_AUTH_TOKEN,
      },
    }
  );
};

export interface Items {
  sku: string;
  qty: number;
}

export interface MedicineOrderBilledItem {
  itemId: string;
  itemName: string;
  batchId: string;
  issuedQty: number;
  mou: number;
  mrp: number;
}

export interface MedCartItemsDetailsResponse {
  productdp: MedicineProduct[];
}

const medCartItemsDetailsApi = (
  itemIds: string[]
): Promise<AxiosResponse<MedCartItemsDetailsResponse>> => {
  return axios.post(
    apiDetails.cartItemDetails,
    {
      params: itemIds.toString(),
    },
    {
      headers: {
        Authorization: apiDetails.authToken,
      },
    }
  );
};

export const reOrderItems = async (
  orderDetails: OrderDetails | LatestOrderDetailsType,
  type: string,
  patientName: string
) => {
  // postReorderMedicines(source, currentPatient);
  // use billedItems for delivered orders
  if (orderDetails) {
    const billedItems =
      orderDetails.medicineOrderShipments &&
      orderDetails.medicineOrderShipments[0] &&
      orderDetails.medicineOrderShipments[0].medicineOrderInvoice &&
      orderDetails.medicineOrderShipments[0].medicineOrderInvoice[0] &&
      orderDetails.medicineOrderShipments[0].medicineOrderInvoice[0]
        .itemDetails;
    const billedLineItems = billedItems
      ? (JSON.parse(billedItems) as MedicineOrderBilledItem[])
      : null;

    const isOfflineOrder = orderDetails.billNumber;

    const lineItems = orderDetails.medicineOrderLineItems || [];
    const lineItemsSkus = billedLineItems
      ? billedLineItems
          .filter((item: MedicineOrderBilledItem) => item.itemId)
          .map((item) => item.itemId)
      : lineItems
          .filter((item) => item.medicineSKU)
          .map((item) => item.medicineSKU!);

    const lineItemsDetails = (
      await medCartItemsDetailsApi(lineItemsSkus)
    ).data.productdp.filter((lineItem: any) => lineItem.sku && lineItem.name);
    const availableLineItemsSkus = lineItemsDetails.map(
      (lineItem: any) => lineItem.sku
    );
    const cartItemsToAdd = lineItemsDetails.map(
      (item: any, index: any) =>
        item.sku &&
        ({
          ...item,
          description: "",
          image: [],
          mou: isOfflineOrder
            ? Math.ceil(
                lineItems[index].price /
                  lineItems[index].mrp /
                  lineItems[index].quantity
              )
            : item.mou,
          quantity: Math.ceil(
            (billedLineItems
              ? billedLineItems[index].issuedQty
              : item.MaxOrderQty < lineItems[index].quantity
              ? item.MaxOrderQty
              : lineItems[index].quantity) || 1
          ),
          isShippable: true,
        } as MedicineCartItem)
    );
    const unAvailableItems =
      availableLineItemsSkus && billedLineItems
        ? billedLineItems
            .filter((item) => !availableLineItemsSkus.includes(item.itemId))
            .map((item) => item.itemName)
        : lineItems
            .filter(
              (item) => !availableLineItemsSkus.includes(item.medicineSKU)
            )
            .map((item) => item.medicineName);

    // Prescriptions
    const prescriptionUrls = (orderDetails.prescriptionImageUrl || "")
      .split(",")
      .map((item) => item.trim())
      .filter((v) => v);
    const medicineNames = (billedLineItems
      ? billedLineItems
          .filter((item) => item.itemName)
          .map((item) => item.itemName)
      : lineItems
          .filter((item) => item.medicineName)
          .map((item) => item.medicineName)
    ).join(",");
    const prescriptionsToAdd = prescriptionUrls.map(
      (item) =>
        ({
          id: item,
          date: format(new Date(), "dd MMM yyyy"),
          doctorName: `Meds Rx ${
            (orderDetails.id &&
              orderDetails.id.substring(0, orderDetails.id.indexOf("-"))) ||
            ""
          }`,
          forPatient: patientName,
          medicines: medicineNames,
          uploadedUrl: item,
        } as EPrescription)
    );

    return {
      items: cartItemsToAdd || [],
      unAvailableItems,
      prescriptions: prescriptionsToAdd || [],
      totalItemsCount: lineItems.length,
      unavailableItemsCount: unAvailableItems.length,
    };
  }
};

export const getMedicineDetailsApi = (
  productSku: string
): Promise<AxiosResponse<MedicineProductDetailsResponse>> => {
  return axios.post(
    apiDetails.medicineDetails,
    { params: productSku },
    {
      headers: {
        Authorization: apiDetails.authToken,
      },
    }
  );
};

interface Cashbacks {
  [type: string]: number;
}

export const useMedicineCashbacks = () => {
  const [cashbacks, setCashbacks] = useState<Cashbacks | null>(null);
  const apolloClient = useApolloClient();

  useEffect(() => {
    if (!cashbacks) {
      apolloClient
        .query<
          GetCashbackDetailsOfPlanById,
          GetCashbackDetailsOfPlanByIdVariables
        >({
          query: GET_CASHBACK_DETAILS_PLAN_BY_ID,
          fetchPolicy: "no-cache",
          variables: {
            plan_id: "CIRCLEPlan",
          },
        })
        .then((response) => {
          setCashbacks(
            (response &&
              response.data &&
              response.data.GetCashbackDetailsOfPlanById &&
              response.data.GetCashbackDetailsOfPlanById.response &&
              response.data.GetCashbackDetailsOfPlanById.response.meta &&
              response.data.GetCashbackDetailsOfPlanById.response.meta
                .cashback) ||
              null
          );
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          console.log("Finished fetch Cashbacks");
        });
    }
  }, [cashbacks]);

  return cashbacks;
};

export const getCategoryTreeForMegaMenu = () => {
  return axios
    .get(`${process.env.NEXT_PUBLIC_247_CDN_URL}/files/categoryTree.json`)
    .then((res) => {
      if (res && res.data && typeof res.data === "object") {
        return res.data;
      }
      return [];
    });
};

export const getAvailableSkuQtyOps = (
  medicineDetails: MedicineProductDetails
): number[] => {
  /* max available quantity for SKU should have a fallback value 1 */
  const maxAvailableQty = Number(
    medicineDetails?.MaxOrderQty ||
      process.env.NEXT_PUBLIC_PHARMACY_MEDICINE_QUANTITY ||
      1
  );

  /* available quantity options range from 1 to maxAvailableQty */
  const availableMedQtyOps = Array.from(
    { length: maxAvailableQty },
    (_, i) => i + 1
  );

  return availableMedQtyOps;
};
